export default __webpack_public_path__ + "static/media/04.706b531a.jpg";